import { render } from "./AdvancedTrainingEditDialog.vue?vue&type=template&id=04fdd9fa"
import script from "./AdvancedTrainingEditDialog.vue?vue&type=script&lang=js"
export * from "./AdvancedTrainingEditDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__